import { DATA_STORE_MAIN, FILTER_STORE, SET_RESULT_COUNT, DATA_STORE_GEOIP } from '../types';

const initialState = {
  data: null,
  filters: null,
  resultCount: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATA_STORE_MAIN: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case FILTER_STORE: {
      return {
        ...state,
        filters: action.payload,
      };
    }
    case SET_RESULT_COUNT: {
      return {
        ...state,
        resultCount: action.count,
      };
    }
    case DATA_STORE_GEOIP: {
      return {
        ...state,
        geoIp: action.geoIp,
      };
    }
    default:
      return state;
  }
};
